const groupsData =[
    {
        name:'SkillShikhun - Your Step to Future',
        link:'https://www.facebook.com/groups/skillshikhun'
    }
]

export default groupsData;